import { IEditarPerguntasERespostasForm } from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";
import {
    EditarPerguntasERespostasServices,
    ListarTipoPerguntaFormularioServices,
    ListarPerguntasERespostarFormServices,
    DeletarPerguntaPesquisaServices,
    CadastrarPerguntasERespostasServices,
} from "../../../../Services/Geral/Formularios/PerguntasERespostas/PerguntasERespostasServices";

import { Controller } from "../../../Controller";

export function EditarPerguntasERespostasController(
    requestBody: IEditarPerguntasERespostasForm
) {
    return Controller(EditarPerguntasERespostasServices(requestBody));
}

export function ListarTipoPerguntaFormularioController() {
    return Controller(ListarTipoPerguntaFormularioServices());
}

export function ListarPerguntasERespostarFormController(idFormulario: number) {
    return Controller(ListarPerguntasERespostarFormServices(idFormulario));
}

export function DeletarPerguntaPesquisaController(
    idPesquisaSatisfacaoPergunta: number
) {
    return Controller(
        DeletarPerguntaPesquisaServices(idPesquisaSatisfacaoPergunta)
    );
}

export function CadastrarPerguntasERespostasController(
    requestBody: IEditarPerguntasERespostasForm
) {
    return Controller(CadastrarPerguntasERespostasServices(requestBody));
}
